import {useEffect, useState} from 'react';

/**
 * Returns a debounced value that updates only after the specified delay
 * when the input value stops changing.
 */
export default function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState<T>(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debounced;
}